import React, { useEffect, useState } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faRupeeSign } from '@fortawesome/free-solid-svg-icons';
import FailureAlert from '../Common/Failure';
import Select from 'react-select';
import VehicleChart from '../Common/VehicleChart';

const ManageSurvey = () => {
    const [SurveyData, setSurveyData] = useState([]);
    const [Customers, setCustomers] = useState([]);
    const [CustomersData, setCustomersData] = useState([]);
    const [SelectedCustomers, setSelectedCustomers] = useState({});
    const [TotalCFT, setTotalCFT] = useState(0);
    const [VehicleRequired, setVehicleRequired] = useState("NA");

    useEffect(() => {
        FetchCustmers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchCustmers = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null) {
            Axiosfetch(baseURL + "GetActiveCustomersByPartnerID", "POST", {
                PartnerID: userData.OrganizationID, limit: 0,
                sorting: -1
            }, CustomerSuccess, Failure);
        }
    };

    const CustomerSuccess = (data) => {
        if (data.length > 0) {
            setCustomersData(data);
            var customerData = [];
            data.forEach(customer => {
                customerData.push({ label: "[#S" + customer.SurveyID + "-" + moment(customer.createdAt).local().format("DDMMYYYY") + "] " + customer.Name, value: customer._id })
            });

            setCustomers(customerData);
        }
        else {
            setCustomersData([]);
            setCustomers([]);
        }
    };

    const FetchSurvey = (customerId) => {
        Axiosfetch(baseURL + "GetSurveyListByCustomerID", "POST", { CustomerID: customerId }, SurveySuccess, Failure);
    };

    const SurveySuccess = (data) => {
        if (data.length > 0) {
            var cftValue = 0;
            data.forEach(survey => {
                cftValue += (survey.CFTValue * survey.Quantity)
            });

            let vehcileData = VehicleChart.filter(v => v.MinCFT <= cftValue && v.MaxCFT >= cftValue);
            setVehicleRequired(vehcileData.length > 0 ? vehcileData[0].TypeOfLoad : "NA");

            setSurveyData(data);
            setTotalCFT(cftValue);
        }
        else {
            setSurveyData({});
            setTotalCFT(0);
        }
    };

    const OnCustomerChange = (customerData) => {
        let customer = customerData ? customerData.value : "";
        if (customer !== "") {
            let cust = CustomersData.filter(c => c._id === customer);
            if (cust.length > 0) {
                setSelectedCustomers(cust[0]);
                FetchSurvey(customer);
            }
            else {
                setSelectedCustomers({});
            }
        }
        else {
            setSurveyData({});
            setSelectedCustomers({});
        }
    };

    const OnApproveSurvey = () => {
        if (SelectedCustomers._id !== undefined) {
            Axiosfetch(baseURL + "ApproveCustomerSurvey", "POST", { ID: SelectedCustomers._id }, SurveyApproveSuccess, Failure);
        }
    };

    const OnCloseSurvey = () => {
        if (SelectedCustomers._id !== undefined) {
            Axiosfetch(baseURL + "CloseSurvey", "POST", { ID: SelectedCustomers._id }, CloseSurveySuccess, Failure);
        }
    };

    const OnRejectSurvey = () => {
        if (SelectedCustomers._id !== undefined) {
            Axiosfetch(baseURL + "RejectCustomerSurvey", "POST", { ID: SelectedCustomers._id }, SurveyRejectSuccess, Failure);
        }
    };

    const CloseSurveySuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            setSelectedCustomers({});
            setCustomers({ label: null, value: null });
            FetchCustmers();
        }
    }

    const SurveyApproveSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            FetchCustmers();
            setSelectedCustomers({ ...SelectedCustomers, SurveyApproved: 1 });
            if (SelectedCustomers._id !== undefined) {
                FetchSurvey(SelectedCustomers._id);
            }
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const SurveyRejectSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            FetchCustmers();
            setSelectedCustomers({ ...SelectedCustomers, SurveyApproved: 2 });
            if (SelectedCustomers._id !== undefined) {
                FetchSurvey(SelectedCustomers._id);
            }
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="offset-md-2 col-md-6 col-12">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Manage Survey</h5>

                    </div>
                    <div className="col-md-4 col-12 align-center">
                        <Select isClearable={true} isSearchable={true} placeholder="Select Survey"
                            options={Customers}
                            onChange={OnCustomerChange}></Select>
                    </div>

                </div>
                <div className="row" style={{ height: "75vh", overflow: "auto", marginTop: "10px" }}>
                    <div className="col-md-5 col-sm-5 align-center">
                        {SelectedCustomers._id !== undefined &&
                            (<div style={{ height: "70vh", borderRight: "1px solid #ccc" }}>
                                <div style={{
                                    padding: "12px", borderTop: "1px solid #ccc", borderBottom: "1px solid #ccc",
                                    borderLeft: "1px solid #ccc",
                                    fontSize: "1.3rem",
                                    backgroundColor: (SelectedCustomers.SurveyApproved === 1 ? "#00b300" : (SelectedCustomers.SurveyApproved === 2 ? "#f02b2b" : "")),
                                    color: ((SelectedCustomers.SurveyApproved === 2 || SelectedCustomers.SurveyApproved === 1) ? "white" : "")
                                }}>Customer : {SelectedCustomers.Name}</div>
                                <div style={{ height: "60vh", overflow: "auto" }}>
                                    <table className="table" style={{ textAlign: "left" }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Company Name</td>
                                                <td> <div>{SelectedCustomers.CompanyName}</div></td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Phone Number</td>
                                                <td>
                                                    <div>
                                                        <a style={{ textDecoration: "none" }} href={`tel:+91${SelectedCustomers.PhoneNumber}`}>{SelectedCustomers.PhoneNumber}</a>

                                                    </div></td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Email ID</td>
                                                <td><div>
                                                    <a className="hover-style" href={`mailto:${SelectedCustomers.EmailID}}`}>{SelectedCustomers.EmailID}</a>
                                                </div></td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Origin Address</td>
                                                <td style={{ maxWidth: "200px" }}><div>{SelectedCustomers.OriginAddress + " , " + SelectedCustomers.OriginCity + " " +
                                                    SelectedCustomers.OriginPincode + " , " + SelectedCustomers.OriginState + " , " +
                                                    SelectedCustomers.OriginCountry}</div></td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Origin Lift</td>
                                                <td>
                                                    <div>{SelectedCustomers.OriginHasLift === 0 ? (<span style={{ color: "red" }}><FontAwesomeIcon icon={faTimes} /></span>)
                                                        : <span style={{ color: "green" }}><FontAwesomeIcon icon={faCheck} /></span>}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Destination Address</td>
                                                <td style={{ maxWidth: "200px" }}><div>{SelectedCustomers.DestinationAddress + " , " + SelectedCustomers.DestinationCity + " " +
                                                    SelectedCustomers.DestinationPincode + " , " + SelectedCustomers.DestinationState + " , " +
                                                    SelectedCustomers.DestinationCountry}</div></td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Destination Lift</td>
                                                <td>
                                                    <div>{SelectedCustomers.DestinationHasLift === 0 ? (<span style={{ color: "red" }}><FontAwesomeIcon icon={faTimes} /></span>)
                                                        : <span style={{ color: "green" }}><FontAwesomeIcon icon={faCheck} /></span>}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Preferred Packing Date</td>
                                                <td>
                                                    <div>{moment(SelectedCustomers.PreferredPackingDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Preferred Moving Date</td>
                                                <td>
                                                    <div>{moment(SelectedCustomers.PreferredMovingDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Preferred Delivery Date</td>
                                                <td>
                                                    <div>{moment(SelectedCustomers.PreferredDeliveryDate).local().format("DD/MM/YYYY hh:mm:ss A")}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Insurance</td>
                                                <td>
                                                    <div>{SelectedCustomers.IsInsured === 0 ? (<span style={{ color: "red" }}><FontAwesomeIcon icon={faTimes} /></span>)
                                                        : <span style={{ color: "green" }}><FontAwesomeIcon icon={faCheck} /></span>}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: "600" }}>Insurance Amount</td>
                                                <td>
                                                    <div><span style={{ paddingRight: "2px" }}><FontAwesomeIcon icon={faRupeeSign} /></span>{SelectedCustomers.InsuranceAmount}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>)
                        }
                    </div>
                    <div className="col-md-7 col-sm-7 align-center">
                        {SelectedCustomers._id !== undefined && SurveyData && SurveyData.length > 0 && (
                            <div style={{ height: "70vh", borderLeft: "1px solid #ccc" }}>
                                <div style={{
                                    padding: "10px", borderTop: "1px solid #ccc", borderBottom: "1px solid #ccc",
                                    borderRight: "1px solid #ccc",
                                    fontSize: "1.3rem", display: "flex",
                                    justifyContent: ((SelectedCustomers.SurveyApproved === 1 || SelectedCustomers.SurveyApproved === 2) ? (SelectedCustomers.Status === 1 ? "space-between" : "space-evenly") : "space-between"),
                                    backgroundColor: (SelectedCustomers.SurveyApproved === 1 ? "#00b300" : (SelectedCustomers.SurveyApproved === 2 ? "#f02b2b" : "")),
                                    color: ((SelectedCustomers.SurveyApproved === 2 || SelectedCustomers.SurveyApproved === 1) ? "white" : "")
                                }}>
                                    <div>Goods Details</div>
                                    {SelectedCustomers.SurveyApproved === 0 && (<div><button onClick={OnApproveSurvey} className="btn btn-General">Approve Survey</button>
                                        <button onClick={OnRejectSurvey} className="btn btn-General">Reject Survey</button></div>)}
                                    {(SelectedCustomers.Status === 1 && SelectedCustomers.SurveyApproved > 0) && (<div><button onClick={OnCloseSurvey} className="btn btn-default">Close Survey</button></div>)}
                                </div>
                                <div style={{ height: "60vh", overflow: "auto" }}>

                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th style={{ backgroundColor: "white", zIndex: "0" }}>Name</th>
                                                <th style={{ backgroundColor: "white", zIndex: "0" }}>Remarks</th>
                                                <th style={{ backgroundColor: "white", zIndex: "0" }}>Quantity</th>
                                                <th style={{ backgroundColor: "white", zIndex: "0" }}>CFT</th>
                                                <th style={{ backgroundColor: "white", zIndex: "0" }}>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {SurveyData.map((survey, index) => (
                                                <tr key={index}>
                                                    <td>{survey.Name}</td>
                                                    <td style={{ width: "300px", wordBreak: "break-word" }}>{survey.Remarks}</td>
                                                    <td>{survey.Quantity}</td>
                                                    <td>{survey.CFTValue}</td>
                                                    <td>{parseInt(survey.Quantity) * parseInt(survey.CFTValue)}</td>
                                                </tr>
                                            ))}
                                            <tr style={{ fontSize: "1.3rem" }}>
                                                <td colSpan="4">Total CFT / Vehicle Load</td>
                                                <td>{TotalCFT} / {VehicleRequired}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>)}
                    </div>
                </div>
                {SelectedCustomers._id === undefined &&
                    (<div style={{ position: "absolute", top: "50%", left: "35%", width: "40%" }}>
                        <div style={{ padding: "10px", backgroundColor: "#ccc", textAlign: "center" }}> Please Select Customer.</div>
                    </div>)}
            </div>
        </div>
    );
};

export default ManageSurvey;